import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(['idWorldOutgoCategory']),
        getBySupplier: (state) => workId => {
            return state.objs.filter(oc => oc.supplier === workId);
        }
    },
    mutations: {
        ...functions.createDefaultMutations(['idWorldOutgoCategory'])
    },
    actions: {
        ...functions.createDefaultActionsWithStore(['idWorldOutgoCategory'])
    },
}